export const SESSION_INVALIDATED_CODE = "SESSION_INVALIDATED_BY_NEW_LOGIN";

export const SESSION_INVALIDATED_MESSAGE =
  "You've been logged out because you logged in on another device or browser.";

export const isSessionInvalidatedError = (message: string): boolean =>
  message.includes("session has been invalidated") ||
  message.includes("SessionInvalidatedException");
